import { pxToRem } from '@modernhealth/vital-components';
import React, { FC } from 'react';
import styled from '@emotion/styled';
import { CareCard, CareCardProps } from 'src/modules/care/components/CareCard';

export interface CareCardPropsWithId extends CareCardProps {
    id: string;
}

interface CareCardRowProps {
    cards: CareCardPropsWithId[];
}

export const CareCardRow: FC<CareCardRowProps> = ({ cards }) => {
    return (
        <Container>
            {cards.map((card, index) => (
                <CareCard key={card.id} {...card} index={index} />
            ))}
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'row',
    gap: pxToRem(16),
    justifyContent: 'space-between',
});
